import React, { Component } from "react";
import PropTypes from "prop-types";

import { Mutation } from "react-apollo";

import { Fieldset, Field, Control, Label, Input } from "rbx";
import Section from "../Section";
import {
  UPDATE_LOCATION_MUTATION,
  DELETE_LOCATION_MUTATION
} from "../../graphql/Locations/Locations.graphql";

import {
  EditFormButtonGroup,
  StateSelect,
  SystemCodeSelect,
  BooleanInput,
  DateInput,
  ZipCodeInput,
  PoorTextEditor
} from "../inputs";
import { getUTCFormattedDate, ourToast as toast } from "../../utils";

class EditLocationForm extends Component {
  state = {
    TimeZoneRecIdRef: "",
    LocationTypeRecIdRef: "",
    LocationID: "",
    LocationName: "",
    Active: "",
    BillToCustomer: "",
    Address1: "",
    Address2: "",
    City: "",
    State: "",
    Zip: "",
    Country: "",
    NumberOfLoadingBays: "",
    NumberOfUnloadingBays: "",
    Scales: "",
    LastUsedDate: "",
    XATADataStation: "",
    SpecialExternalInstructions: "",
    InternalNotes: "",
    ...this.props.location
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    const updates = { [e.target.name]: value };
    if (e.target.name === "NumberOfLoadingBays") {
      updates.NumberOfUnloadingBays = value;
    }
    this.setState({ ...updates });
  };

  render() {
    const {
      LocationID,
      LocationName,
      Active,
      BillToCustomer,
      Address1,
      Address2,
      City,
      State,
      Zip,
      Country,
      NumberOfLoadingBays,
      NumberOfUnloadingBays,
      Scales,
      LastUsedDate,
      XATADataStation,
      SpecialExternalInstructions,
      InternalNotes,
      TimeZoneRecIdRef,
      LocationTypeRecIdRef
    } = this.state;

    const { setModalOpen } = this.props;

    return (
      <Mutation
        mutation={UPDATE_LOCATION_MUTATION}
        refetchQueries={["ALL_LOCATIONS_QUERY"]}
        variables={{
          data: {
            LocationID,
            LocationName,
            Active,
            BillToCustomer,
            Address1,
            Address2,
            City,
            State,
            Zip,
            Country,
            NumberOfLoadingBays,
            NumberOfUnloadingBays: parseInt(NumberOfUnloadingBays),
            Scales: Scales ? "Y" : "N",
            LastUsedDate: getUTCFormattedDate(LastUsedDate),
            XATADataStation,
            SpecialExternalInstructions,
            InternalNotes,
            TimeZoneRecIdRef: parseInt(TimeZoneRecIdRef),
            LocationTypeRecIdRef: parseInt(LocationTypeRecIdRef)
          },
          where: { RecId: parseInt(this.props.location.RecId) }
        }}
      >
        {(updateLocation, { loading, error }) => (
          <form
            id="edit-location"
            method="POST"
            onSubmit={async e => {
              e.preventDefault();
              try {
                await updateLocation();
                setModalOpen();
                toast.success("Location updated successfully.");
              } catch (err) {
                toast.error("Error updating Location.");
              }
            }}
          >
            <Fieldset disabled={loading}>
              <Section size="small" title="Edit Location">
                <Field kind="group">
                  <Control>
                    <Label>Location Id</Label>
                    <Input
                      required
                      autocomplete="new"
                      name="LocationID"
                      value={LocationID}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Location Name</Label>
                    <Input
                      required
                      autocomplete="new"
                      name="LocationName"
                      type="text"
                      value={LocationName}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Field>
                    <Control>
                      <Label>Active</Label>
                      <BooleanInput
                        name="Active"
                        value={Active}
                        onChange={this.onChange}
                      />
                    </Control>
                  </Field>
                </Field>
                <Field>
                  <Label>Bill To Customer</Label>
                  <Control>
                    <Input
                      autocomplete="new"
                      name="BillToCustomer"
                      type="text"
                      value={BillToCustomer}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field multiline kind="group">
                  <Control expanded>
                    <Label>Address 1</Label>
                    <Input
                      autocomplete="new"
                      name="Address1"
                      type="text"
                      value={Address1}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Address 2</Label>
                    <Input
                      autocomplete="new"
                      name="Address2"
                      type="text"
                      value={Address2}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>City</Label>
                    <Input
                      autocomplete="new"
                      name="City"
                      type="text"
                      value={City}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>State</Label>
                    <StateSelect
                      name="State"
                      size=""
                      value={State}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Zip Code</Label>
                    <ZipCodeInput
                      name="Zip"
                      value={Zip}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control>
                    <Label>Country</Label>
                    <Input
                      autocomplete="new"
                      name="Country"
                      type="text"
                      value={Country}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <SystemCodeSelect
                      icon="globe"
                      label="Time Zone"
                      lookup={{ Category: "Company", Code: "Time Zone" }}
                      name="TimeZoneRecIdRef"
                      value={TimeZoneRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <SystemCodeSelect
                      icon="globe"
                      label="Location Type"
                      lookup={{ Category: "Location", Code: "LocType" }}
                      name="LocationTypeRecIdRef"
                      value={LocationTypeRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control expanded>
                    <Label>Number Of Loading Bays</Label>
                    <Input
                      autocomplete="new"
                      name="NumberOfLoadingBays"
                      type="number"
                      value={NumberOfLoadingBays}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Number Of Unloading Bays</Label>
                    <Input
                      autocomplete="new"
                      label="NumberOfUnloadingBays"
                      name="NumberOfUnloadingBays"
                      type="number"
                      value={NumberOfUnloadingBays}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Scales</Label>
                    <BooleanInput
                      name="Scales"
                      value={Scales}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <Label>Last Used Date</Label>
                    <DateInput
                      name="LastUsedDate"
                      value={LastUsedDate}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <SystemCodeSelect
                      icon="globe"
                      label="Xata Data Station"
                      lookup={{ Category: "Location", Code: "XataCode" }}
                      name="XATADataStation"
                      value={XATADataStation}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <Label>Special External Instructions</Label>
                    <PoorTextEditor
                      name="SpecialExternalInstructions"
                      value={SpecialExternalInstructions}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <Label>Internal Notes</Label>
                    <PoorTextEditor
                      name="InternalNotes"
                      value={InternalNotes}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <EditFormButtonGroup
                  deleteMutation={DELETE_LOCATION_MUTATION}
                  form="edit-location"
                  refetchQueries={["ALL_LOCATIONS_QUERY"]}
                  variables={{ where: { RecId: this.props.location.RecId } }}
                  onComplete={setModalOpen}
                />
              </Section>
            </Fieldset>
          </form>
        )}
      </Mutation>
    );
  }
}

EditLocationForm.propTypes = {
  setModalOpen: PropTypes.func,
  location: PropTypes.object
};

export default EditLocationForm;
